@use '@design/design-tokens/typography/typography' as *;

.legendPriceRoot {
  display: flex;
  align-items: center;
  gap: 12px;
}

.priceContainer {
  display: flex;
  align-items: center;
  font-family: var(--font-roboto-mono);
  gap: 8px;
  @include typography-v2-body-sm;
}
